var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hover-menu" }, [
    _c(
      "div",
      { staticClass: "handle-icon" },
      [
        _c(
          "div",
          {
            staticStyle: { "margin-bottom": "24px" },
            on: {
              click: function ($event) {
                return _vm.$emit("allScreen")
              },
            },
          },
          [
            _c("div", { staticClass: "menu" }, [
              _c("i", {
                staticClass: "iconfont",
                class: _vm.isAllScreen
                  ? "icona-10quanping-xiao"
                  : "iconquanping1",
              }),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showAdd,
                expression: "showAdd",
              },
            ],
            staticStyle: { "margin-bottom": "24px" },
            on: {
              click: function ($event) {
                return _vm.$emit("addReport")
              },
            },
          },
          [_vm._m(0)]
        ),
        _c(
          "el-popover",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.$slots.menu,
                expression: "$slots.menu",
              },
            ],
            attrs: {
              appendToBody: false,
              popperOptions: _vm.popperOptions,
              placement: "left-end",
              trigger: "hover",
            },
          },
          [
            _c("div", { staticClass: "list" }, [_vm._t("menu")], 2),
            _c("div", { attrs: { slot: "reference" }, slot: "reference" }, [
              _c("div", { staticClass: "menu" }, [
                _c("i", { staticClass: "iconfont icona-07gengduo" }),
              ]),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "menu", staticStyle: { background: "#fe9d3e" } },
      [_c("i", { staticClass: "iconfont iconadd2" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }